/* Indigrey size guide v2 — two tabs (Body / Garment), single data source: the
   inches table from the product metafield. cm is computed, never stored.
   Works with the theme's dialog cloning via event delegation. */
(function () {
  'use strict';
  if (window.__igSizeGuideV2) return;
  window.__igSizeGuideV2 = true;

  var TOP_ORDER = ['Chest', 'Shoulder', 'Waist', 'Hip', 'Sleeve Length', 'Garment Length'];
  var BOTTOM_ORDER = ['Waist', 'Hip', 'Thigh', 'Length'];
  var TOP_LABEL_MAP = { 'Hips': 'Hip', 'Length': 'Garment Length', 'Sleeve': 'Sleeve Length' };

  /* Measurement names become COLUMN HEADINGS (see tableHTML), so the two long
     ones are shortened for the header only. The full name is still what the
     ordering logic and the metafield use — this map is display, nothing else.
     The flat-lay key beside the table spells them out in full anyway. */
  var SHORT_LABEL = { 'Sleeve Length': 'Sleeve', 'Garment Length': 'Length' };

  /* Brand-wide body chart. Migrated 2026-07-23 to the XS–XXL system: the body
     measurements themselves are unchanged (a 34" bust is still a 34" bust) —
     the size NAMES shifted one position, so 34" is now XS rather than S, and a
     sixth column was added for the new XXL continuing each row's own +2" step.
     sizes[] and every rows[][1] should stay the same length; a value with no
     partner renders as an em dash rather than silently shortening the table.

     These six bust numbers are also printed on the product page size chips,
     from snippets/indigrey-size-map.liquid. Change one without the other and
     the chip and the chart disagree — which is the exact bug that map exists
     to prevent. */
  var BODY_CHART = {
    sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    rows: [
      ['Bust', ['34', '36', '38', '40', '42', '44']],
      ['Waist', ['28', '30', '32', '34', '36', '38']],
      ['Hip', ['37', '39', '41', '43', '45', '47']]
    ]
  };

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function toCm(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return v;
    return String(Math.round(n * 2.54));
  }

  function parseTable(tbl) {
    var headCells = tbl.querySelectorAll('thead th, thead td');
    if (!headCells.length) {
      var firstRow = tbl.querySelector('tr');
      if (!firstRow) return null;
      headCells = firstRow.querySelectorAll('th, td');
    }
    var sizes = [];
    for (var i = 1; i < headCells.length; i++) sizes.push(headCells[i].textContent.trim());
    var rows = [];
    var bodyRows = tbl.querySelectorAll('tbody tr');
    if (!bodyRows.length) bodyRows = tbl.querySelectorAll('tr');
    for (var r = 0; r < bodyRows.length; r++) {
      var cells = bodyRows[r].querySelectorAll('th, td');
      if (cells.length < 2) continue;
      var label = cells[0].textContent.trim();
      if (!label || label.toLowerCase() === 'measurement') continue;
      var vals = [];
      for (var c = 1; c < cells.length; c++) vals.push(cells[c].textContent.trim());
      rows.push([label, vals]);
    }
    if (!rows.length || !sizes.length) return null;
    return { sizes: sizes, rows: rows };
  }

  function parseSource(html) {
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var tables = [];
    var caption = '';
    var nodes = holder.querySelectorAll('h1,h2,h3,h4,h5,h6,table');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.tagName.toLowerCase() === 'table') {
        var parsed = parseTable(node);
        if (parsed) { parsed.caption = caption; tables.push(parsed); }
        caption = '';
      } else {
        caption = node.textContent.trim();
      }
    }
    return tables;
  }

  function cleanCaption(caption) {
    var c = caption.replace(/size\s*chart/i, '').trim();
    return c || caption;
  }

  function normalize(t) {
    var isBottom = /bottom/i.test(t.caption || '');
    var map = isBottom ? {} : TOP_LABEL_MAP;
    var order = isBottom ? BOTTOM_ORDER : TOP_ORDER;
    var rows = t.rows.map(function (r) {
      return [map[r[0]] || r[0], r[1]];
    });
    var sorted = [];
    for (var i = 0; i < order.length; i++) {
      for (var j = 0; j < rows.length; j++) {
        if (rows[j] && rows[j][0] === order[i]) { sorted.push(rows[j]); rows[j] = null; }
      }
    }
    for (var k = 0; k < rows.length; k++) if (rows[k]) sorted.push(rows[k]);
    return {
      caption: t.caption ? cleanCaption(t.caption) : '',
      isBottom: isBottom,
      sizes: t.sizes,
      rows: sorted
    };
  }

  /* ONE SIZE PER ROW.

     The data arrives measurement-major — rows[] is [label, [value per size]] —
     and this function turns it on its side: sizes run DOWN the first column,
     measurements run ACROSS the top.

     Why: a shopper opens the size guide holding a number and looking for a
     letter. Searching a column of right-aligned numbers is far easier than
     tracking along a wide row, and once she finds her bust the letter is at
     the head of that row with her waist and hip already beside it — one
     vertical scan, one horizontal read, no diagonal.

     It also suits a phone. The body chart becomes four columns instead of
     seven, so the type can breathe. Garment charts carry up to six
     measurements and stay seven columns wide either way, which is why
     .sg2-table-wrap is allowed to scroll sideways.

     The unit is not repeated in the headings. The IN / CM toggle sits
     directly above the table with the active one underlined, and the note
     below spells out the tolerance in words. Three statements of the same
     fact would cost a column's width for nothing. */
  function tableHTML(t, unit) {
    var html = '<div class="sg2-table-wrap">';
    if (t.caption) html += '<p class="sg2-table-caption">' + esc(t.caption) + '</p>';
    html += '<table class="sg2-table"><thead><tr><th scope="col">Size</th>';
    for (var h = 0; h < t.rows.length; h++) {
      var name = t.rows[h][0];
      html += '<th scope="col">' + esc(SHORT_LABEL[name] || name) + '</th>';
    }
    html += '</tr></thead><tbody>';
    for (var s = 0; s < t.sizes.length; s++) {
      html += '<tr><th scope="row">' + esc(t.sizes[s]) + '</th>';
      for (var c = 0; c < t.rows.length; c++) {
        var v = t.rows[c][1][s];
        if (v === undefined || v === null || v === '') {
          html += '<td>&#8212;</td>';
        } else {
          html += '<td>' + esc(unit === 'in' ? v : toCm(v)) + '</td>';
        }
      }
      html += '</tr>';
    }
    html += '</tbody></table></div>';
    return html;
  }

  function initRoot(root) {
    if (root.getAttribute('data-sg-ready')) return;
    var src = root.querySelector('[data-sg-chart-source]');
    var tables = [];
    if (src) tables = parseSource(src.innerHTML || '').map(normalize);
    if (!tables.length && src) {
      /* Unparseable chart: show the raw metafield content as-is. */
      var fallback = root.querySelector('[data-sg-tables]');
      if (fallback) fallback.innerHTML = '<div class="sg2-raw rte">' + src.innerHTML + '</div>';
    }
    try {
      root.setAttribute('data-sg-data', JSON.stringify({ tables: tables }));
    } catch (e) { /* leave fallback markup in place */ }
    root.setAttribute('data-sg-ready', '1');
    render(root);
  }

  function getData(root) {
    try {
      return JSON.parse(root.getAttribute('data-sg-data') || '{"tables":[]}');
    } catch (e) { return { tables: [] }; }
  }

  function render(root) {
    var unit = root.getAttribute('data-sg-active-unit') || 'in';
    var data = getData(root);
    var container = root.querySelector('[data-sg-tables]');
    if (container && data.tables.length) {
      var html = '';
      for (var i = 0; i < data.tables.length; i++) html += tableHTML(data.tables[i], unit);
      container.innerHTML = html;
    }
    var hasBottom = false;
    for (var b = 0; b < data.tables.length; b++) if (data.tables[b].isBottom) hasBottom = true;
    var bottomFig = root.querySelector('[data-sg-figure="bottom"]');
    if (bottomFig) bottomFig.hidden = !hasBottom;

    var bodyContainer = root.querySelector('[data-sg-body-table]');
    if (bodyContainer) {
      bodyContainer.innerHTML = tableHTML({
        caption: '', sizes: BODY_CHART.sizes, rows: BODY_CHART.rows
      }, unit);
    }

    var tolerances = root.querySelectorAll('[data-sg-tolerance]');
    for (var tI = 0; tI < tolerances.length; tI++) {
      tolerances[tI].textContent = unit === 'in' ? '±0.5 inch' : '±1 cm';
    }

    var unitBtns = root.querySelectorAll('[data-sg-unit-btn]');
    for (var u = 0; u < unitBtns.length; u++) {
      var active = unitBtns[u].getAttribute('data-sg-unit-btn') === unit;
      unitBtns[u].classList.toggle('active', active);
      unitBtns[u].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function selectTab(root, name) {
    var tabs = root.querySelectorAll('[data-sg-tab]');
    for (var i = 0; i < tabs.length; i++) {
      var active = tabs[i].getAttribute('data-sg-tab') === name;
      tabs[i].classList.toggle('active', active);
      tabs[i].setAttribute('aria-selected', active ? 'true' : 'false');
    }
    var panels = root.querySelectorAll('[data-sg-panel]');
    for (var p = 0; p < panels.length; p++) {
      panels[p].hidden = panels[p].getAttribute('data-sg-panel') !== name;
    }
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-sg-root]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  document.addEventListener('click', function (e) {
    var tabBtn = e.target.closest ? e.target.closest('[data-sg-tab]') : null;
    var unitBtn = e.target.closest ? e.target.closest('[data-sg-unit-btn]') : null;
    if (!tabBtn && !unitBtn) return;
    var root = (tabBtn || unitBtn).closest('[data-sg-root]');
    if (!root) return;
    if (!root.getAttribute('data-sg-ready')) initRoot(root);
    if (tabBtn) {
      e.preventDefault();
      selectTab(root, tabBtn.getAttribute('data-sg-tab'));
    } else {
      e.preventDefault();
      root.setAttribute('data-sg-active-unit', unitBtn.getAttribute('data-sg-unit-btn'));
      render(root);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
